import { setGlobalCanHelpers } from 'src/config/services/globalPrototypes.ts'
import type { InjectionKey } from 'vue'

const GLOBAL_RULE = 'GLOBAL_RULE'
const DIRECTIVE_NAME = 'can'

export const CanKey = Symbol(`$${DIRECTIVE_NAME}`) as InjectionKey<(verb: string, instance: object) => boolean>

// TODO VUE3: Type this
export default {
  // @ts-expect-error: Vue plugin install signature is not typed here for compatibility with Vue3
  install(app) {
    // @ts-expect-error: userAccessor is intentionally loosely typed for compatibility with various can object shapes
    const userAccessor = (verb, instance) => {
      if (!instance) {
        console.warn(`v-can Object is ${instance}`)
        return false
      }
      if (!instance.can) {
        console.warn(`v-can 'can' property is not defined on: ${instance}`)
        return false
      }
      if (instance.can[verb] === undefined) {
        console.warn(`v-can method is not defined: ${verb}`)
        return false
      }

      return instance.can[verb] === 1
    }

    // Default options
    const strict = false
    const options = Object.assign({
      acl: { strict: false },
      strict: false,
      assumeGlobal: !strict,
    })

    // Register directive -> v-can
    app.directive(DIRECTIVE_NAME, {
      // @ts-expect-error: Vue 2.x directive signature is not compatible with Vue 3.x
      mounted(el, binding) {
        const behaviour = binding.modifiers.disable ? 'disable' : 'hide'

        let verb, subject, params
        const verbArg = binding.arg
        if (Array.isArray(binding.value)) {
          [verb, subject, params] = binding.modifiers.global ? arrayToGlobalExprTpl(binding) : arrayToExprTpl(binding)
        } else if (verbArg && typeof binding.value === 'object') {
          verb = verbArg
          subject = binding.value
          params = []
        } else if (binding.value === undefined && !binding.modifiers.global && options.assumeGlobal) {
          verb = verbArg
          subject = GLOBAL_RULE
          params = []
        }

        if (options.assumeGlobal && !subject) {
          subject = GLOBAL_RULE
          params = params || []
          verb = verb || verbArg
        }

        if (!verb || !subject) {
          throw new Error('Missing verb or subject')
        }

        // @ts-expect-error: userAccessor may accept extra params for compatibility with various can object shapes
        const ok = userAccessor(verb, subject, ...params)
        const not = binding.modifiers.not

        if ((ok && not) || (!ok && !not)) {
          if (behaviour === 'hide') {
            commentNode(el)
          } else if (behaviour === 'disable') {
            el.disabled = true
          }
        }
      },
    })

    // @ts-expect-error: userAccessor is intentionally loosely typed for compatibility with various can object shapes
    const helperFn = (...args) => userAccessor(...args)
    // @ts-expect-error: userAccessor is intentionally loosely typed for compatibility with various can object shapes
    helperFn.not = (...args) => !userAccessor(...args)

    // Register global prototypes for useCan composable
    app.provide(CanKey, helperFn)

    // To make "can" helpers available in non-vue files via "GlobalPrototypes.can"
    setGlobalCanHelpers(app, helperFn)
  },
}

// Comment node replacement (like v-if="false")
// @ts-expect-error: commentNode is used for both Vue 2 and Vue 3 compatibility
function commentNode(el) {
  const comment = document.createComment(' ')
  Object.defineProperty(comment, 'setAttribute', {
    value: () => undefined,
  })

  if (el.parentNode) {
    el.parentNode.replaceChild(comment, el)
  }
}

// Maps binding.value of type array to expression tuple
// @ts-expect-error: arrayToExprTpl is intentionally loosely typed for compatibility with various can object shapes
const arrayToExprTpl = ({ arg, value }) => [arg || value[0], arg ? value[0] : value[1], arg ? value.slice(1) : value.slice(2)]

// Maps binding.value of type array to global expression tuple
// @ts-expect-error: arrayToGlobalExprTpl is intentionally loosely typed for compatibility with various can object shapes
const arrayToGlobalExprTpl = ({ arg, value }) => [arg || value[0], GLOBAL_RULE, arg ? value : value.slice(1)]
